module.exports = __webpack_public_path__ + "img/arrow_left_2.c9fa46f9.svg";